import { PARAMETERS, EVENT_TYPES, EVENTS } from '@root/tracking/constants';
import { getSourcePageFrom } from '@root/tracking/helpers';

const seenTourbookExplanationAction = () => (dispatch, getState) => {
  dispatch({
    type: 'TOURBOOK_EXPLANATION_SEEN',
    payload: {
      meta: {
        analytics: {
          eventType: EVENT_TYPES.track,
          event: EVENTS.tourbookInteraction,
          action: PARAMETERS.seenTourbookExplanation,
          sourcePage: getSourcePageFrom(getState())!,
          sourceContent: PARAMETERS.tourbookOverlay,
        },
      },
    },
  });
};
type SeeTourbookExplanationAction = typeof seenTourbookExplanationAction;
const seeTourbookExplanation = () => seenTourbookExplanationAction();

export type Action = SeeTourbookExplanationAction;

export default {
  seeTourbookExplanation,
};
